@for (column of columns(); track column; let i = $index) {
<div class="uve-container blog-read-more-container" [class]="getRowCss(column, i)" [ngClass]="column.styleClass">
  <custom-dot-cms-container class="w-100" [layoutContainers]="column.containers" />
</div>
}
